import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

function Termsandservice() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const navigate = useNavigate();

  return (
    <div className="my-16 flex justify-center">
      <div className="w-[90%] pt-2">
        <h1 className="text-textcolor text-3xl lg:text-[40px] font-bold leading-[48px]">
          Terms of Service
        </h1>

        <p className="text-textcolor/60 text-[15px] pt-3">
          <strong>Last Updated:</strong> April 28, 2026
        </p>

        <p className="text-textcolor/60 text-[15px] pt-3">
          Welcome to <strong>Team Edelstein Systems</strong> ("TES," "the Platform," "we," "us," or "our").
        </p>

        <p className="text-textcolor/60 text-[15px] pt-3">
          By accessing or using TES, you agree to be bound by these Terms. If you do not agree, do not use the Platform.
        </p>

        {/* SECTION 1 */}
        <h2 className="text-textcolor text-xl pt-7 font-semibold">
          1. Description of Service
        </h2>
        <p className="text-textcolor/60 text-[15px] pt-2">
          TES is an internal platform for real estate operations including deal tracking, commissions, CRM, tasks, document parsing, and analytics.
        </p>

        {/* SECTION 2 */}
        <h2 className="text-textcolor text-xl pt-7 font-semibold">
          2. Eligibility and Authorized Use
        </h2>
        <ul className="list-disc ml-6 text-textcolor/60 text-[15px] pt-2 space-y-2">
          <li>Must be an approved member or collaborator</li>
          <li>Must have authorized access credentials</li>
          <li>Must be at least 18 years old</li>
        </ul>
        <p className="text-textcolor/60 text-[15px] pt-2">
          Accounts are non-transferable and credentials must not be shared.
        </p>

        {/* SECTION 3 */}
        <h2 className="text-textcolor text-xl pt-7 font-semibold">
          3. User Accounts and Roles
        </h2>
        <ul className="list-disc ml-6 text-textcolor/60 text-[15px] pt-2 space-y-2">
          <li><strong>Agent:</strong> Access to assigned data</li>
          <li><strong>Admin / TC:</strong> Manage deals and workflows</li>
          <li><strong>Super Admin:</strong> Full access</li>
          <li><strong>Bookkeeper:</strong> Financial data access</li>
        </ul>
        <p className="text-textcolor/60 text-[15px] pt-2">
          You are responsible for all activity under your account.
        </p>

        {/* SECTION 4 */}
        <h2 className="text-textcolor text-xl pt-7 font-semibold">
          4. Confidentiality
        </h2>
        <ul className="list-disc ml-6 text-textcolor/60 text-[15px] pt-2 space-y-2">
          <li>All data is strictly confidential</li>
          <li>Use only for Team Edelstein business</li>
          <li>No unauthorized sharing or exporting</li>
          <li>Must comply with real estate laws and Coldwell Banker policies</li>
        </ul>

        {/* SECTION 5 */}
        <h2 className="text-textcolor text-xl pt-7 font-semibold">
          5. Acceptable Use
        </h2>
        <ul className="list-disc ml-6 text-textcolor/60 text-[15px] pt-2 space-y-2">
          <li>No unlawful or fraudulent use</li>
          <li>No data misrepresentation</li>
          <li>No malware or harmful code</li>
          <li>No reverse engineering</li>
          <li>No unauthorized data scraping</li>
          <li>No platform interference</li>
          <li>No unlawful marketing or discrimination</li>
        </ul>

        {/* SECTION 6 */}
        <h2 className="text-textcolor text-xl pt-7 font-semibold">
          6. Third-Party Services
        </h2>
        <ul className="list-disc ml-6 text-textcolor/60 text-[15px] pt-2 space-y-2">
          <li>Google Workspace</li>
          <li>Firebase / Google Cloud</li>
          <li>Anthropic API</li>
          <li>Coldwell Banker systems</li>
        </ul>
        <p className="text-textcolor/60 text-[15px] pt-2">
          Use of these services is subject to their own terms.
        </p>

        {/* SECTION 7 */}
        <h2 className="text-textcolor text-xl pt-7 font-semibold">
          7. Client and Transaction Data
        </h2>
        <p className="text-textcolor/60 text-[15px] pt-2">
          Users must maintain accurate records and comply with legal and brokerage obligations.
        </p>

        {/* SECTION 8 */}
        <h2 className="text-textcolor text-xl pt-7 font-semibold">
          8. Intellectual Property
        </h2>
        <p className="text-textcolor/60 text-[15px] pt-2">
          The Platform is the exclusive property of Team Edelstein. No rights are granted beyond authorized use.
        </p>

        {/* SECTION 9 */}
        <h2 className="text-textcolor text-xl pt-7 font-semibold">
          9. User-Submitted Content
        </h2>
        <p className="text-textcolor/60 text-[15px] pt-2">
          You grant us a license to use submitted content for platform operations.
        </p>

        {/* SECTION 10 */}
        <h2 className="text-textcolor text-xl pt-7 font-semibold">
          10. Suspension and Termination
        </h2>
        <ul className="list-disc ml-6 text-textcolor/60 text-[15px] pt-2 space-y-2">
          <li>Violation of Terms</li>
          <li>End of relationship</li>
          <li>Security concerns</li>
        </ul>

        {/* SECTION 11 */}
        <h2 className="text-textcolor text-xl pt-7 font-semibold">
          11. Disclaimers
        </h2>
        <p className="text-textcolor/60 text-[15px] pt-2">
          The Platform is provided "as is" with no guarantees. You must verify all data and calculations.
        </p>

        {/* SECTION 12 */}
        <h2 className="text-textcolor text-xl pt-7 font-semibold">
          12. Limitation of Liability
        </h2>
        <p className="text-textcolor/60 text-[15px] pt-2">
          Liability is limited to $100 to the maximum extent permitted by law.
        </p>

        {/* SECTION 13 */}
        <h2 className="text-textcolor text-xl pt-7 font-semibold">
          13. Indemnification
        </h2>
        <p className="text-textcolor/60 text-[15px] pt-2">
          You agree to indemnify Team Edelstein against claims arising from your use.
        </p>

        {/* SECTION 14 */}
        <h2 className="text-textcolor text-xl pt-7 font-semibold">
          14. Governing Law
        </h2>
        <p className="text-textcolor/60 text-[15px] pt-2">
          Governed by Minnesota law. Jurisdiction: Anoka County courts.
        </p>

        {/* SECTION 15 */}
        <h2 className="text-textcolor text-xl pt-7 font-semibold">
          15. Changes to Terms
        </h2>
        <p className="text-textcolor/60 text-[15px] pt-2">
          Continued use after updates constitutes acceptance.
        </p>

        {/* SECTION 16 */}
        <h2 className="text-textcolor text-xl pt-7 font-semibold">
          16. Entire Agreement
        </h2>
        <p className="text-textcolor/60 text-[15px] pt-2">
          These Terms and the Privacy Policy form the full agreement.
        </p>

        {/* SECTION 17 */}
        <h2 className="text-textcolor text-xl pt-7 font-semibold">
          17. Contact
        </h2>

        <p className="text-textcolor/60 text-[15px] pt-3">
          Team Edelstein
        </p>
        <p className="text-textcolor/60 text-[15px]">
          Attn: Henry Edelstein
        </p>
        <p className="text-themeblue text-[15px] underline pt-2">
          henry@teamedelstein.com
        </p>
   
      </div>
    </div>
  );
}
export default Termsandservice;